export const templateColumnConfigs = [
  {
    header: 'Process Area*',
    key: 'processArea',
    width: 35,
    required: true,
    example: 'Sample Process Area',
    type: 'Text',
  },
  {
    header: 'Replacement Time*',
    key: 'replacementTime',
    width: 25,
    required: true,
    example: '12',
    type: 'Number (Months)',
  },
  {
    header: 'Replacement Cost*',
    key: 'replacementCost',
    width: 25,
    required: true,
    example: '1000',
    type: 'Number (USD)',
  },
];
